// import BootstrapVue from 'bootstrap-vue'
// Vue.use(BootstrapVue)

import Vue from 'vue'
import { Layout, Modal, Image, Nav, Navbar, FormInput, Button, Tooltip, Tabs, Card, ListGroup, FormRadio, FormGroup, FormCheckbox, Alert, Table} from 'bootstrap-vue/es/components'
Vue.use(Layout)
Vue.use(Modal)
Vue.use(Image)
Vue.use(Nav)
Vue.use(Navbar)
Vue.use(FormInput)
Vue.use(Button)
Vue.use(Tooltip)
Vue.use(Tabs)
Vue.use(ListGroup)
Vue.use(FormRadio)
Vue.use(FormGroup)
Vue.use(FormCheckbox)
Vue.use(Alert)
Vue.use(Table)
Vue.use(Card)
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
